import { toMap } from '@dsee/util/arrays.js';

export const tagKinds = Object.freeze([
    { id: 'industry', name: 'Отрасли', class: 'gray' },
    { id: 3, name: 'Сферы применения', class: 'neutral' },
    { id: 2, name: 'Технологии', class: 'neutral' },
    { id: 1, name: 'Сегменты', class: 'neutral' },
]);


export const tagKindsMap = toMap(tagKinds);

export const getTagKindStyleClass = (id) => tagKindsMap[id]?.class ?? '';
export const getTagKindName = (id) => tagKindsMap[id]?.name ?? '';


export function tagsToMap(tags) {
    return tags.map(it => {
        const kind = it.kind?.id ?? it.kind;
        return {
            ...it,
            kind,
            class: getTagKindStyleClass(kind),
            kindName: getTagKindName(kind),
        };
    });
}

export function tagsSortByKind(tags) {
    return tags.sort((a, b) => {
        if (a.kind === b.kind) {
            return a.name.localeCompare(b.name);
        }

        return b.kind - a.kind;
    });
}
